import { createContext, useContext } from 'react';

type OrgScopedHomeFeatureContextType = {
  enabled: boolean;
  isLoading: boolean;
};

const OrgScopedHomeFeatureContext = createContext<OrgScopedHomeFeatureContextType>({
  enabled: false,
  isLoading: false,
});

export const useOrgScopedHomeFeature = () => useContext(OrgScopedHomeFeatureContext);

export default OrgScopedHomeFeatureContext;
